const headers = [
  // 伝票番号
  {
    text: 'nextengine.nextengine_ec-receiveorder-receiveorder-id',
    value: 'receiveOrderId',
    sortable: false,
    width: '5%',
    align: 'center'
  },
  // 受注日
  {
    text: 'nextengine.nextengine_ec-receiveorder-receiveorder-date',
    value: 'receiveOrderDate',
    sortable: false,
    width: '5%',
    align: 'center'
  },
  // 受注番号
  {
    text: 'nextengine.nextengine_ec-receiveorder-receiveorder-shop-cut-form-id',
    value: 'receiveOrderShopCutFormId',
    sortable: false,
    width: '7%',
    align: 'center'
  },
  // 店舗
  {
    text: 'common.input_shop',
    value: 'receiveOrderShopName',
    sortable: false,
    width: '7%',
    align: 'center'
  },
  // 購入者名
  {
    text: 'nextengine.nextengine_ec-receiveorder-purchaser-name',
    value: 'receiveOrderPurchaserName',
    sortable: false,
    width: '7%',
    align: 'center'
  },
  // 合計金額
  {
    text: 'payment.payment_total-price-no-colon',
    value: 'receiveOrderTotalAmount',
    sortable: false,
    width: '7%',
    align: 'center'
  },
  // 送り先名
  {
    text: 'nextengine.nextengine_ec-receiveorder-consignee-name',
    value: 'receiveOrderConsigneeName',
    sortable: false,
    width: '7%',
    align: 'center'
  },
  // 発送方法
  {
    text: 'nextengine.nextengine_ec-receiveorder-delivery-name',
    value: 'receiveOrderDeliveryName',
    sortable: false,
    width: '7%',
    align: 'center'
  },
  // 受注詳細
  {
    text: 'nextengine.nextengine_ec-receiveorder-detail',
    value: 'detail',
    sortable: false,
    width: '5%',
    align: 'center'
  },
  // ステータス
  {
    text: 'sale.sale_status',
    value: 'saleStatus',
    sortable: false,
    width: '7%',
    align: 'center'
  }
]

export default { headers }
